package pl.decks.posthog.config

@Suppress("unused")
enum class PersonProfiles(val jsValue: String) {
    IDENTIFIED_ONLY("identified_only"),
    ALWAYS("always"),
    ;
}
